import { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import Form from "../Forms/Form";
import NewsCard from "../common/NewsCard";
import { fetchToken } from "../../Auth";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { GlobalUrl, GlobalImg, adminURL } from "../../global";
import AllRoutes from "../../AllRoutes";
import { Helmet, HelmetProvider } from "react-helmet-async";
import AOS from "aos";
import "aos/dist/aos.css";
import { toast } from "react-toastify";
import dummyImage from "../../assets/img/media/hospitality.png";

const News = () => {
  const [sortedNewsData, setSortedNewsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newsData, setNewsData] = useState([]);
  const [newsImages, setNewsImages] = useState({});
  const navigate = useNavigate();

  const getNews = async () => {
    try {
      const response = await axios.get(`/backend/get_news/1`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${fetchToken("nuprice_access_token")}`,
        },
      });
      setNewsData(response.data);
    } catch (err) {
      console.error("Error", err);
      if (err.response?.status === 401) {
        console.error("Error", err);
        if (err.response.status === 400) {
          navigate("/error");
        }
        if (err.response.status === 401) {
          navigate("/login");
        }
      }
    }
  };

  // Function to fetch news image
  const fetchNewsImage = async (itemId) => {
    try {
      // Find the news item to get its image type
      const newsItem = newsData.find((item) => item.id === itemId);
      const imgId = `img-${itemId}`;

      // Get the file extension from the image type
      let fileExtension = "jpg"; // Default extension
      if (newsItem && newsItem[imgId]?.type) {
        const imageType = newsItem[imgId].type;
        if (imageType === "image/jpeg" || imageType === "image/jpg") {
          fileExtension = "jpeg";
        } else if (imageType === "image/png") {
          fileExtension = "png";
        } else if (imageType === "image/gif") {
          fileExtension = "gif";
        }
      }
      const imageID = `news-${itemId.toString()}-${imgId}.${fileExtension}`;

      // Updated URL format to include the file extension
      const response = await axios.get(`/backend/get_news_image/${imageID}`, {
        headers: {
          Authorization: `Bearer ${fetchToken("nuprice_access_token")}`,
        },
      });

      // Store the image URL in state
      setNewsImages((prev) => ({
        ...prev,
        [itemId]: response.data,
      }));

      return response.data; // This should be the presigned URL
    } catch (error) {
      console.error(`Error fetching image for news item ${itemId}:`, error);
      return dummyImage; // Return dummy image on error
    }
  };

  // Load news data
  useEffect(() => {
    getNews();
  }, []);

  // Process news data when it changes
// Process news data when it changes
useEffect(() => {
  try {
    if (newsData.length > 0) {
      setSortedNewsData(newsData);

      // Fetch images for all news items
      newsData.forEach((item) => {
        fetchNewsImage(item.id);
      });
    } else {
      // Make sure we set sorted news data to empty array
      setSortedNewsData([]);
    }
    
    // Always set loading to false, regardless of whether we have news or not
    setLoading(false);
  } catch (error) {
    console.error("Error loading news data:", error);
    setLoading(false);
  }
}, [newsData]);

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  const props = {
    template: 2,
    form_name: "news-page", // Page name
    fields: [
      {
        name: "email",
        required: true,
      },
    ],
    recipients_group_id: 1,
    handleApiResponse: (res) => {
      toast.dismiss();
      if (res.status == "success") {
        toast.success("Form Submitted successfully");
      } else {
        toast.error(res.data);
      }
    },
  };
  const formatDate = (dateString) => {
    if (!dateString) return "";

    // Parse the date string
    const date = new Date(dateString);

    // Array of month names
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Get day, month name, and year
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    // Return formatted date
    return `${day} ${month} ${year}`;
  };

  return (
    <HelmetProvider>
      <Helmet>
        <title>
          Stay Ahead with the Latest News, Updates, and Business Insights
        </title>
        <link rel="canonical" href={`${GlobalUrl}${AllRoutes.news}`} />
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />

        <meta property="type" content="website" />
        <meta name="theme-color" content="#ffffff" />
        <meta name="_token" content="" />
        <meta name="robots" content="noodp" />

        <meta
          name="description"
          content="Discover what the media is saying about Sciative. Explore our latest news, industry features, and insights into AI-driven pricing and business solutions."
        />
        <meta property="og:locale" content="en_US" />
        <meta
          property="og:title"
          content="Stay Ahead with the Latest News, Updates, and Business Insights"
        />
        <meta
          property="og:description"
          content="Discover what the media is saying about Sciative. Explore our latest news, industry features, and insights into AI-driven pricing and business solutions."
        />

        <meta property="og:hashtag" content="#ai" />
        <meta content="image/*" property="og:image:type" />
        <meta property="og:url" content={`${GlobalUrl}${AllRoutes.news}`} />
        <meta
          property="og:site_name"
          content="Sciative Solutions - We Price Right"
        />

        <meta property="og:image" content={GlobalImg} />
        <meta property="og:type" content="website" />
      </Helmet>
      <section className="smallBanner news_bg">
        <div className="container" data-aos="new-animation">
          <p className="small_head">Sciative in Media</p>
          <h1 className="about_para w-80 ">
            Sciative in the Spotlight: Explore Sciative's Latest News & Insights
          </h1>
          <p className="about_para_2">
            Stay informed, stay ahead: your source for the latest news and
            business insights on Sciative.
          </p>
          <div className="mt-5 col-sm-12 col-md-8 col-lg-6">
            <p className="bold about_para_2 mb-4">
              Subscribe to our weekly research articles for more data-driven
              insights.
            </p>
            <Form {...props} />
          </div>
        </div>
      </section>
      <section className="career_img news_img">
        <div
          className="container d-flex flex-column align-items-center"
          data-aos="new-animation"
        >
          <div className="w-100 d-flex justify-content-center align-items-center">
            <h2 className="bigHead text-center">
              Sciative Chronicles: Latest Updates & Insights
            </h2>
          </div>
          {loading ? (
            <div className="text-center py-5">Loading news...</div>
          ) : sortedNewsData.length === 0 ? (
            <div className="text-center py-5">No news items available</div>
          ) : (
            <div className="news-pyramid-container w-100">
              {(() => {
                // Calculate the grid structure
                const totalItems = sortedNewsData.length;
                const fullRows = Math.floor(totalItems / 3);
                const remainingItems = totalItems % 3;

                // Generate rows
                const rows = [];

                // Add full rows (3 items each)
                for (let i = 0; i < fullRows; i++) {
                  rows.push({
                    startIndex: i * 3,
                    count: 3,
                  });
                }

                // Add the last row with remaining items (if any)
                if (remainingItems > 0) {
                  rows.push({
                    startIndex: fullRows * 3,
                    count: remainingItems,
                  });
                }

                // Render the rows
                return rows.map((row, rowIndex) => {
                  const startIdx = row.startIndex;
                  const endIdx = startIdx + row.count;
                  const rowItems = sortedNewsData.slice(startIdx, endIdx);

                  // Calculate offset for centering if needed
                  let offsetClass = "";

                  if (row.count === 2) {
                    // Center 2 items
                    offsetClass = "offset-lg-2";
                  } else if (row.count === 1) {
                    // Center 1 item
                    offsetClass = "offset-lg-4";
                  }

                  return (
                    <div
                      key={`row-${rowIndex}`}
                      className={`${rowIndex > 0 ? "mt-4" : "mt-4"} w-100 row`}
                    >
                      {rowItems.map((item, itemIndex) => (
                        <div
                          key={item.id}
                          className={`col-md-6 col-lg-4 d-flex ${
                            itemIndex === 0 ? offsetClass : ""
                          }`}
                        >
                          <NewsCard
                            type="news"
                            url={item.url}
                            img={newsImages[item.id]}
                            date={formatDate(item.publishDate)}
                            title={item.title}
                          />
                        </div>
                      ))}
                    </div>
                  );
                });
              })()}
            </div>
          )}
        </div>
      </section>
    </HelmetProvider>
  );
};

export default News;
